// angular
import {Component, OnInit, inject, input} from "@angular/core";
import {NgClass} from "@angular/common";
// material angular
import {MatIconModule} from "@angular/material/icon";
// services
import {LayoutService} from "../shared/services/layout.service";

@Component({
  selector: "app-menu-button",
  templateUrl: "./menu-button.component.html",
  styleUrls: ["./menu-button.component.scss"],
  standalone: true,
  imports: [NgClass, MatIconModule],
})
export class MenuButtonComponent implements OnInit {
  public menuIsOpen?: boolean;
  readonly class = input("!text-gray-A100");

  // dependencies
  private _layoutService = inject(LayoutService);

  constructor() {}

  ngOnInit(): void {
    this._layoutService.menuIsOpen$.subscribe((isOpen) => {
      this.menuIsOpen = isOpen;
    });
  }
  public toggleSidebar() {
    this._layoutService.menuIsOpen$.next(
      !this._layoutService.menuIsOpen$.value
    );
  }
}
